var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcChevronRightRegular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.863 19.637a.9.9 0 0 1 0-1.273L14.227 12 7.863 5.637a.9.9 0 0 1 1.273-1.273l7 7a.9.9 0 0 1 0 1.273l-7 7a.9.9 0 0 1-1.273 0",
  clipRule: "evenodd"
})));
export default SvgIcChevronRightRegular;